'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _basicClassCreator = require('../utils/basicClassCreator');

var _basicClassCreator2 = _interopRequireDefault(_basicClassCreator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _basicClassCreator2.default)('Spacer', 'mdl-layout-spacer');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-mdl/lib/Layout/Spacer.js
 ** module id = 57
 ** module chunks = 0
 **/